import React from 'react';
import PropTypes from 'prop-types';
import { Converter } from 'showdown';

export const Markdown = (props) => {
	const { content } = props;
	const settings = {
		simpleLineBreaks: true,
	};

	props = {
		...props,
		...{
			content: undefined,
		},
	};

	const converter = new Converter({
		...settings,
		...props,
	});

	return <HTML {...props} content={converter.makeHtml(content)} />;
};

Markdown.propTypes = {
	content: PropTypes.string.isRequired,
};

export const HTML = (props) => {
	const html = {
		__html: props.content,
	};

	props = {
		...props,
		...{
			content: undefined,
		},
	};

	return <div {...props} dangerouslySetInnerHTML={html} />;
};

HTML.propTypes = {
	content: PropTypes.node.isRequired,
};

export const Conditional = ({ condition, wrapper, children }) => {
	return condition ? wrapper(children) : children;
};

Conditional.propTypes = {
	condition: PropTypes.any,
	wrapper: PropTypes.func.isRequired,
	children: PropTypes.element.isRequired,
};
